module.exports = __webpack_public_path__ + "media/react/views/blank-profile-2fda6558cd58b877e14faf4d698f771a.png";